import React from "react";
import { useTranslation } from "react-i18next";
// import "./TBA-OCF.css";

function TBAOCF() {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto">
      <h1 className="text-center mb-4">{t("TBA - OCF")}</h1>
      <p>{t("TBA_OCF_Content1")}</p>
      <p>
        {t("TBA_OCF_Content2")}{" "}
        <a
          href="https://indico.wacren.net/event/202/"
          target="_blank"
          rel="noreferrer"
        >
          {t("TBA_OCF_Link")}
        </a>{" "}
        . {t("TBA_OFC_Content2_1")}
      </p>
      <p>{t("TBA_OCF_Content3")}</p>

      <div className="text-center mt-4">
        <img
          src="/assets/images/OFC.png"
          alt="OCF"
          className="img-fluid"
          style={{ maxWidth: "30%", height: "auto" }}
        />
      </div>
    </div>
  );
}

export default TBAOCF;
